<div class="demographics-container" *ngIf="demographicData">
  <div class="row demographic-row">
    <div class="col-sm-6 justify-padding-right">
      <div class="chart-container gender-chart">
        <demographic-gender-chart *ngIf="hasGenderChartData"
          [chartData]="genderChartData"
          [chartTitle]="'INFLUENCER.demographic.gender_chart.title' | translate"
          [height]="pieHeight"
          [width]="maxWidthGenderChart"
          [pieCenter]="pieCenter"
          [pieSize]="pieSize"
          [pieInnerSize]="pieInnerSize"
          [titleStyling]="pieTitleStyling"
          [titleTooltip]="'info_box.influencer.gender' | translate"
          [listLegendPlaceholder]="['Male', 'Female']"
          [legend]="pieLegend">
        </demographic-gender-chart>
        <div class="chart-placeholder-container" *ngIf="!hasGenderChartData">
          <div class="d-flex flex-row align-items-center">
            <div class="gender-par-age-chart-title">{{'INFLUENCER.demographic.gender_chart.title' | translate}}</div>
            <div class="tooltip-title-wrapper">
              <achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.gender' | translate"></achoo-icon-tooltip>
            </div>
          </div>
          <div class="chart-placeholder">
            <div class="chart-placeholder-content">
              <div class="data-not-available">{{'INFLUENCER.CHART.DATA_NOT_AVAILABLE' | translate}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 justify-padding-left">
      <div class="chart-container">
        <new-gender-per-age-chart *ngIf="isGenderPerAgeAvailabel"
                                  [chartData]="genderPerAgeChart"
                                  [maxPercent]="genderPerAgeChartMaxPercent">
        </new-gender-per-age-chart>
        <div class="chart-placeholder-container" *ngIf="!isGenderPerAgeAvailabel">
          <div class="d-flex flex-row align-items-center">
            <div class="gender-par-age-chart-title">{{'INFLUENCER.CHART.NEW_GENDER_PER_AGE.TITLE' | translate}}</div>
            <div class="tooltip-title-wrapper">
              <achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.gender_per_age' | translate"></achoo-icon-tooltip>
            </div>
          </div>
          <div class="chart-placeholder">
            <div class="chart-placeholder-content">
              <div class="data-not-available">{{'INFLUENCER.CHART.DATA_NOT_AVAILABLE' | translate}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6 justify-padding-right">
      <div class="chart-container country-chart">
        <achoo-pie-chart *ngIf="hasCountriesChartData"
          [chartData]="countriesChartData"
          [chartTitle]="'INFLUENCER.CHART.COUNTRIES_PIE_CHART_TITLE' | translate"
          [height]="pieHeight"
          [pieCenter]="pieCenter"
          [pieSize]="pieSize"
          [pieInnerSize]="pieInnerSize"
          [titleStyling]="pieTitleStyling"
          [legend]="overridenLegend"
          [listLegendPlaceholder]="['Demark', 'UAE', 'United State', 'United Kingdom']"
          [titleTooltip]="'info_box.influencer.countries' | translate"
          [isDemographicPage]="true">
        </achoo-pie-chart>
        <div class="chart-placeholder-container" *ngIf="!hasCountriesChartData">
          <div class="d-flex flex-row align-items-center" >
            <span class="audience-type-placeholder-title">{{'INFLUENCER.CHART.COUNTRIES_PIE_CHART_TITLE' | translate}}</span>
            <div class="tooltip-title-wrapper">
              <achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.audience_type' | translate"></achoo-icon-tooltip>
            </div>
          </div>
          <div class="chart-placeholder">
            <div class="chart-placeholder-content">
              <div class="data-not-available">{{'INFLUENCER.CHART.DATA_NOT_AVAILABLE' | translate}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 justify-padding-left">
      <div class="chart-container audience-type-chart">
        <achoo-pie-chart *ngIf="hasAudienceTypeData"
                        [chartData]="audienceTypeChartData"
                        [chartTitle]="'INFLUENCER.CHART.AUDIENCE_TYPE_PIE_CHART_TITLE' | translate"
                        [height]="pieHeight"
                        [pieCenter]="pieCenter"
                        [pieSize]="pieSize"
                        [pieInnerSize]="pieInnerSize"
                        [titleStyling]="pieTitleStyling"
                        [forPayingUser]="true"
                        [listLegendPlaceholder]="['Real People', 'Influencers', 'Mass followers', 'Suspicious Accounts']"
                        [legend]="overridenLegend"
                        [titleTooltip]="'info_box.influencer.audience_type' | translate"
                        [isDemographicPage]="true">
        </achoo-pie-chart>
        <div class="chart-placeholder-container" *ngIf="!hasAudienceTypeData">
          <div class="d-flex flex-row align-items-center">
            <span class="audience-type-placeholder-title">{{'INFLUENCER.CHART.AUDIENCE_TYPE_PIE_CHART_TITLE' | translate}}</span>
            <div class="tooltip-title-wrapper">
              <achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.audience_type' | translate"></achoo-icon-tooltip>
            </div>
          </div>
          <div class="chart-placeholder">
            <div class="chart-placeholder-content">
              <div class="data-not-available">{{'INFLUENCER.CHART.DATA_NOT_AVAILABLE' | translate}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="chart-container bar-chart audience-int-chart" *ngIf="demographicData.audienceInterest">
    <div class="row">
      <div class="col-sm-12 d-flex flex-row align-items-center">
        <span class="bar-chart-title">{{'INFLUENCER.CHART.NEW_AUDIENCE_INTERESTS_CHART_TITLE' | translate}}</span>
        <div class="tooltip-title-wrapper">
          <achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.audience_interests' | translate"></achoo-icon-tooltip>
        </div>
      </div>
      <div class="col-md-12">
        <div class="row" *ngIf="hasAudienceInterestData">
          <div class="col-sm-6 first-audience-interest">
            <demographic-bar-chart [series]="firstHalfAudienceInterestChartData"
                              [isLeftSide]="true"
                              [showIndex]="true"
                              [forPayingUser]="true"
                              [isNormalLine]="true"
                              [maxValue]="audienceInterestMaxValue">
            </demographic-bar-chart>
          </div>
          <div class="col-sm-6 second-audience-interest">
            <demographic-bar-chart [series]="secondHalfAudienceInterestChartData"
                              [isLeftSide]="true"
                              [showIndex]="true"
                              [startIndex]="startingIndexOfSecondHalf"
                              [forPayingUser]="true"
                              [isNormalLine]="true"
                              [maxValue]="audienceInterestMaxValue">
            </demographic-bar-chart>
          </div>
        </div>
        <div class="chart-placeholder-container" *ngIf="!hasAudienceInterestData">
          <div class="chart-placeholder">
            <div class="chart-placeholder-content">
              <div class="data-not-available">{{'INFLUENCER.CHART.DATA_NOT_AVAILABLE' | translate}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row section-content">
    <div class="col-sm-6 justify-padding-right">
      <div class="chart-container bar-chart-city">
        <div class="d-flex flex-row align-items-center">
          <span class="bar-chart-title">{{'hype_auditor_demographic.cities.title' | translate}}</span>
          <div class="tooltip-title-wrapper">
            <achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.audience_city' | translate"></achoo-icon-tooltip>
          </div>
        </div>
        <demographic-bar-chart *ngIf="hasCitiesChartData"
                         [series]="citiesBarChartData"
                         [showIndex]="true"
                         [isLeftSide]="true"
                         [chartBgColor]="languageChartColor"
                         [forPayingUser]="true"
                         [placeholderKeywords]="['United State', 'Denmark', 'England', 'United Arab Emirates', 'Germany']"
                         [isNormalLine]="true"
                         [maxLine]="5">
        </demographic-bar-chart>
        <div class="chart-placeholder" *ngIf="!hasCitiesChartData">
          <div class="chart-placeholder-content">
            <div class="data-not-available">{{'INFLUENCER.CHART.DATA_NOT_AVAILABLE' | translate}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 justify-padding-left" *ngIf="languagesBarChartData">
      <div class="chart-container bar-chart-lang">
        <div class="d-flex flex-row align-items-center">
          <span class="bar-chart-title">{{'hype_auditor_demographic.languages.title' | translate}}</span>
          <div class="tooltip-title-wrapper">
            <achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.audience_lang' | translate"></achoo-icon-tooltip>
          </div>
        </div>
        <demographic-bar-chart *ngIf="hasLanguagesChartData"
                          [series]="languagesBarChartData"
                          [showIndex]="true"
                          [isLeftSide]="true"
                          [forPayingUser]="true"
                          [chartBgColor]="languageChartColor"
                          [placeholderKeywords]="['English', 'Spain', 'Danish', 'French', 'Abaric']"
                          [isNormalLine]="true"
                          [maxLine]="5">
        </demographic-bar-chart>
        <div class="chart-placeholder" *ngIf="!hasLanguagesChartData">
          <div class="chart-placeholder-content">
            <div class="data-not-available">{{'INFLUENCER.CHART.DATA_NOT_AVAILABLE' | translate}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="message-popup freemium" *ngIf="isFreeUser && !isAdmin">
      <div class="title">{{fallbackTitle}}</div>
      <div class="sub-title">{{fallbackMessage}}</div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/new-influencer-demographic/new-influencer-demographic.component.html